import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { Option } from '@common-fe/common-fe';

import { api } from '@/api';
import { ACCOUNT_FUNDS } from '@/common/paths';

export const QUERY_KEY = 'GET_ACCOUNT_FUNDS_LIST';

interface Response {
  id: number;
  name: string;
  symbol: string;
}

const useGetAccountFundsQuery = () => {
  const { isLoading, data, isSuccess } = useQuery([QUERY_KEY], () =>
    // TODO: is not exists
    api.get<Response[]>(ACCOUNT_FUNDS)
  );

  const formattedData = useMemo(() => {
    const list = data?.data || [];
    const newList: Option[] = list.map((item) => ({
      key: `${item.id}`,
      title: item.symbol,
      value: item.symbol,
    }));
    return newList;
  }, [data?.data]);
  return {
    data: formattedData,
    isLoading,
    isSuccess,
  };
};

export default useGetAccountFundsQuery;
